import { log } from '../../../utils/log';
import { VIEW_PATH } from './routes';

export const HANDLE_SUBMISSION = 'HANDLE_SUBMISSION';
export const SET_QUESTIONS_COMPLETED = 'SET_QUESTIONS_COMPLETED';
export const UPDATE_SCHEMA = 'UPDATE_SCHEMA';
export const UPDATE_FORM_QUESTIONS = 'UPDATE_FORM_QUESTIONS';
export const UPDATE_FORM_PROGRESS = 'UPDATE_FORM_PROGRESS';
export const HIDE_QUESTION = 'HIDE_QUESTION';
export const SHOW_QUESTION = 'SHOW_QUESTION';
export const REQUIRE_QUESTION = 'REQUIRE_QUESTION';
export const UNREQUIRE_QUESTION = 'UNREQUIRE_QUESTION';
export const CLEAR_REDIRECT_TO = 'CLEAR_REDIRECT_TO';
export const REDIRECT = 'REDIRECT';

export const reducer = (state, action) => {
  __DEVELOPMENT__ && log('[FormRenderer:ACTION]', action.type, action);
  switch (action.type) {
    case REDIRECT:
      return {
        ...state,
        redirectTo: action.redirectTo,
      };
    case HANDLE_SUBMISSION:
      return {
        ...state,
        isNew: action.isNew,
        isReadOnly: action.isReadOnly,
        data: action.data,
        initialValues: action.data,
        redirectTo: action.redirectTo,
        redirecting: action.redirectTo && action.redirectTo !== VIEW_PATH,
        submitted: true,
      };
    case CLEAR_REDIRECT_TO:
      return {
        ...state,
        redirectTo: null,
      };
    case UPDATE_SCHEMA:
      return {
        ...state,
        validationSchema: action.validationSchema,
      };
    case UPDATE_FORM_QUESTIONS:
      return {
        ...state,
        required: { ...state.required, ...action.required },
        hidden: {
          ...state.hidden,
          ...action.hidden,
        },
      };
    case UPDATE_FORM_PROGRESS:
      return {
        ...state,
        questionsTotal: action.questionsTotal,
        questionsCompleted: action.questionsCompleted,
      };
    case HIDE_QUESTION:
      return {
        ...state,
        hidden: { ...state.hidden, [action.question.name]: true },
      };
    case SHOW_QUESTION:
      return {
        ...state,
        hidden: { ...state.hidden, [action.question.name]: false },
      };
    case REQUIRE_QUESTION:
      return {
        ...state,
        required: { ...state.required, [action.question.name]: true },
      };
    case UNREQUIRE_QUESTION:
      return {
        ...state,
        required: { ...state.required, [action.question.name]: false },
      };
    default:
      return state;
  }
};
